import { capitalize } from '@attain-apps/string-utils'

import { UserFriendlyError } from './user-friendly-error'

/**
 * Enables type-checking that is not affected by having multiple versions of
 * this library installed
 */
// The string here is used as the type description for the type checker
const MARKER_SYMBOL = Symbol.for('@attain-apps/NotImplementedError')

/**
 * Request is valid, but not currently implemented
 */
export class NotImplementedError extends UserFriendlyError {
  // NOTE: must be all upper case to avoid naming collision with the class name
  public static override readonly NAME: string = 'NotImplementedError'
  public override readonly name: string = NotImplementedError.NAME

  // Used by TypeChecker
  private readonly [MARKER_SYMBOL] = true as const

  constructor(
    { description = 'request' }: NotImplementedError.constructor.Options = {},
    actualError?: Error,
  ) {
    super(`${capitalize(description)} is not currently supported`, actualError)
  }
}
export namespace NotImplementedError {
  export namespace constructor {
    export interface Options {
      /**
       * Description of the request or situation that is not currently supported
       *
       * @default 'request'
       */
      description?: string
    }
  }

  // NOTE: not using @attain-apps/type-guards as that would introduce circular imports
  export function isNotImplementedError(
    val: unknown,
  ): val is NotImplementedError {
    return !!(val as NotImplementedError)?.[MARKER_SYMBOL]
  }
}
